// Mock data for properties
import { PropertyCardProps } from './PropertyCard';

// Helper function to generate Nigerian addresses
const generateNigerianAddress = (city: string, state: string) => {
  return {
    city,
    state,
    zip: ''
  };
};

// Generate Nigerian rentals
export const rentProperties: PropertyCardProps['property'][] = [
  {
    id: "rent1",
    imageUrl: "/images/avatars/placeholder.png",
    title: "Modern 2-bedroom apartment",
    address: generateNigerianAddress("Lekki", "Lagos"),
    description: "Luxurious 2-bedroom apartment with balcony and sea view in Lekki Phase 1.",
    price: 850000,
    reviewCount: 42,
    averageRating: 4.5,
    status: "For Rent",
    slug: "modern-2-bedroom-lekki",
    beds: 2,
    baths: 1.5,
    sqft: 980,
    isVerified: true,
    daysListed: 3
  },
  {
    id: "rent2",
    imageUrl: "/images/avatars/placeholder.png",
    title: "Spacious 3-bedroom apartment",
    address: generateNigerianAddress("Victoria Island", "Lagos"),
    description: "Elegant 3-bedroom apartment with city views in a secured estate.",
    price: 1200000,
    reviewCount: 27,
    averageRating: 4.2,
    status: "For Rent",
    slug: "spacious-3-bedroom-vi",
    beds: 3,
    baths: 2,
    sqft: 1450,
    isNew: true
  },
  {
    id: "rent3",
    imageUrl: "/images/avatars/placeholder.png",
    title: "Luxury studio apartment",
    address: generateNigerianAddress("Ikoyi", "Lagos"),
    description: "Premium studio apartment with modern amenities and 24/7 security.",
    price: 650000,
    reviewCount: 35,
    averageRating: 4.6,
    status: "For Rent",
    slug: "luxury-studio-ikoyi",
    beds: 1,
    baths: 1,
    sqft: 650,
    daysListed: 7
  },
  {
    id: "rent4",
    imageUrl: "/images/avatars/placeholder.png",
    title: "Cozy 1-bedroom flat",
    address: generateNigerianAddress("Surulere", "Lagos"),
    description: "Comfortable 1-bedroom flat with balcony and shared pool.",
    price: 450000,
    reviewCount: 19,
    averageRating: 4.0,
    status: "For Rent",
    slug: "cozy-1-bedroom-surulere",
    beds: 1,
    baths: 1,
    sqft: 550
  },
  {
    id: "rent5",
    imageUrl: "/images/avatars/placeholder.png",
    title: "Furnished 2-bedroom flat",
    address: generateNigerianAddress("Yaba", "Lagos"),
    description: "Fully furnished 2-bedroom flat close to tech hubs and shopping centers.",
    price: 750000,
    reviewCount: 23,
    averageRating: 4.3,
    status: "For Rent",
    slug: "furnished-2-bedroom-yaba",
    beds: 2,
    baths: 2,
    sqft: 850,
    isVerified: true,
    daysListed: 2
  },
  {
    id: "rent6",
    imageUrl: "/images/avatars/placeholder.png",
    title: "3-bedroom apartment with BQ",
    address: generateNigerianAddress("Ikeja GRA", "Lagos"),
    description: "Spacious 3-bedroom apartment with boys' quarters in a quiet neighborhood.",
    price: 1500000,
    reviewCount: 31,
    averageRating: 4.7,
    status: "For Rent",
    slug: "3-bedroom-bq-ikeja",
    beds: 3,
    baths: 3,
    sqft: 1800,
    isNew: true
  },
  {
    id: "rent7",
    imageUrl: "/images/avatars/placeholder.png",
    title: "4-bedroom duplex",
    address: generateNigerianAddress("Ajah", "Lagos"),
    description: "Beautiful 4-bedroom duplex with garden and children's play area.",
    price: 2000000,
    reviewCount: 17,
    averageRating: 4.4,
    status: "For Rent",
    slug: "4-bedroom-duplex-ajah",
    beds: 4,
    baths: 4.5,
    sqft: 2200
  },
  {
    id: "rent8",
    imageUrl: "/images/avatars/placeholder.png",
    title: "Service studio apartment",
    address: generateNigerianAddress("Lekki", "Lagos"),
    description: "Serviced studio apartment with 24/7 power and water supply.",
    price: 700000,
    reviewCount: 28,
    averageRating: 4.3,
    status: "For Rent",
    slug: "service-studio-lekki",
    beds: 1,
    baths: 1,
    sqft: 500,
    isVerified: true
  },
  {
    id: "rent9",
    imageUrl: "/images/avatars/placeholder.png",
    title: "2-bedroom bungalow",
    address: generateNigerianAddress("Magodo", "Lagos"),
    description: "Cozy 2-bedroom bungalow in a family-friendly environment.",
    price: 900000,
    reviewCount: 15,
    averageRating: 4.1,
    status: "For Rent",
    slug: "2-bedroom-bungalow-magodo",
    beds: 2,
    baths: 2,
    sqft: 900,
    daysListed: 14
  },
  {
    id: "rent10",
    imageUrl: "/images/avatars/placeholder.png",
    title: "1-bedroom penthouse",
    address: generateNigerianAddress("Victoria Island", "Lagos"),
    description: "Luxury 1-bedroom penthouse with stunning ocean views.",
    price: 1800000,
    reviewCount: 12,
    averageRating: 4.8,
    status: "For Rent",
    slug: "1-bedroom-penthouse-vi",
    beds: 1,
    baths: 1.5,
    sqft: 750,
    isNew: true
  },
  {
    id: "rent11",
    imageUrl: "/images/avatars/placeholder.png",
    title: "3-bedroom terrace",
    address: generateNigerianAddress("Oniru", "Lagos"),
    description: "Modern 3-bedroom terrace house with study and outdoor space.",
    price: 1700000,
    reviewCount: 22,
    averageRating: 4.5,
    status: "For Rent",
    slug: "3-bedroom-terrace-oniru",
    beds: 3,
    baths: 3,
    sqft: 1650,
    isVerified: true
  },
  {
    id: "rent12",
    imageUrl: "/images/avatars/placeholder.png",
    title: "2-bedroom flat with gym",
    address: generateNigerianAddress("Ikoyi", "Lagos"),
    description: "Modern 2-bedroom flat in a complex with gym and swimming pool.",
    price: 1100000,
    reviewCount: 19,
    averageRating: 4.2,
    status: "For Rent",
    slug: "2-bedroom-flat-gym-ikoyi",
    beds: 2,
    baths: 2,
    sqft: 1100,
    daysListed: 5
  },
];

// Generate Nigerian sales
export const saleProperties: PropertyCardProps['property'][] = [
  {
    id: "sale1",
    imageUrl: "/images/avatars/placeholder.png",
    title: "Luxury 5-bedroom villa",
    address: generateNigerianAddress("Banana Island", "Lagos"),
    description: "Exquisite 5-bedroom villa with private pool and garden.",
    price: 450000000,
    reviewCount: 15,
    averageRating: 4.8,
    status: "For Sale",
    slug: "luxury-villa-banana-island",
    beds: 5,
    baths: 6,
    sqft: 5500,
    isVerified: true
  },
  {
    id: "sale2",
    imageUrl: "/images/avatars/placeholder.png",
    title: "4-bedroom townhouse",
    address: generateNigerianAddress("Lekki Phase 1", "Lagos"),
    description: "Beautiful 4-bedroom townhouse with modern architecture.",
    price: 180000000,
    reviewCount: 23,
    averageRating: 4.5,
    status: "For Sale",
    slug: "4-bedroom-townhouse-lekki",
    beds: 4,
    baths: 4.5,
    sqft: 3200,
    isNew: true
  },
  {
    id: "sale3",
    imageUrl: "/images/avatars/placeholder.png",
    title: "3-bedroom apartment",
    address: generateNigerianAddress("Victoria Island", "Lagos"),
    description: "Elegant 3-bedroom apartment with ocean view.",
    price: 120000000,
    reviewCount: 18,
    averageRating: 4.3,
    status: "For Sale",
    slug: "3-bedroom-apartment-vi",
    beds: 3,
    baths: 3,
    sqft: 2100,
    daysListed: 21
  },
  {
    id: "sale4",
    imageUrl: "/images/avatars/placeholder.png",
    title: "5-bedroom detached house",
    address: generateNigerianAddress("Ikoyi", "Lagos"),
    description: "Luxurious 5-bedroom detached house with cinema room and gym.",
    price: 550000000,
    reviewCount: 11,
    averageRating: 4.9,
    status: "For Sale",
    slug: "5-bedroom-detached-ikoyi",
    beds: 5,
    baths: 6,
    sqft: 6000,
    isVerified: true
  },
  {
    id: "sale5",
    imageUrl: "/images/avatars/placeholder.png",
    title: "4-bedroom semi-detached",
    address: generateNigerianAddress("Parkview Estate", "Lagos"),
    description: "Modern 4-bedroom semi-detached house with BQ and garden.",
    price: 280000000,
    reviewCount: 14,
    averageRating: 4.6,
    status: "For Sale",
    slug: "4-bedroom-semi-parkview",
    beds: 4,
    baths: 4,
    sqft: 3800,
    daysListed: 7
  },
  {
    id: "sale6",
    imageUrl: "/images/avatars/placeholder.png",
    title: "3-bedroom terrace house",
    address: generateNigerianAddress("Osapa London", "Lagos"),
    description: "Elegant 3-bedroom terrace house in a secured estate.",
    price: 95000000,
    reviewCount: 20,
    averageRating: 4.2,
    status: "For Sale",
    slug: "3-bedroom-terrace-osapa",
    beds: 3,
    baths: 3.5,
    sqft: 2400,
    isNew: true
  },
  {
    id: "sale7",
    imageUrl: "/images/avatars/placeholder.png",
    title: "2-bedroom apartment",
    address: generateNigerianAddress("Ikate", "Lagos"),
    description: "Affordable 2-bedroom apartment in a prime location.",
    price: 60000000,
    reviewCount: 25,
    averageRating: 4.0,
    status: "For Sale",
    slug: "2-bedroom-apartment-ikate",
    beds: 2,
    baths: 2,
    sqft: 1100
  },
  {
    id: "sale8",
    imageUrl: "/images/avatars/placeholder.png",
    title: "4-bedroom duplex",
    address: generateNigerianAddress("Chevron", "Lagos"),
    description: "Beautiful 4-bedroom duplex with all rooms en-suite.",
    price: 150000000,
    reviewCount: 16,
    averageRating: 4.4,
    status: "For Sale",
    slug: "4-bedroom-duplex-chevron",
    beds: 4,
    baths: 5,
    sqft: 3600,
    daysListed: 14,
    isVerified: true
  },
  {
    id: "sale9",
    imageUrl: "/images/avatars/placeholder.png",
    title: "6-bedroom mansion",
    address: generateNigerianAddress("Banana Island", "Lagos"),
    description: "Luxurious 6-bedroom mansion with swimming pool and cinema.",
    price: 750000000,
    reviewCount: 9,
    averageRating: 5.0,
    status: "For Sale",
    slug: "6-bedroom-mansion-banana",
    beds: 6,
    baths: 7,
    sqft: 8500,
    isNew: true
  },
];

// Sponsored listings
export const sponsoredListings: PropertyCardProps['property'][] = [
  {
    id: "spon1",
    imageUrl: "/images/avatars/placeholder.png",
    title: "Premium serviced apartment",
    address: generateNigerianAddress("Admiralty Way, Lekki", "Lagos"),
    description: "Premium serviced apartment with lagoon view and 24/7 electricity.",
    price: 2500000,
    status: "Sponsored",
    slug: "premium-serviced-apartment",
    beds: 3,
    baths: 2,
    sqft: 1800,
    isVerified: true,
    isNew: true
  },
  {
    id: "spon2",
    imageUrl: "/images/avatars/placeholder.png",
    title: "Ultra-modern penthouse",
    address: generateNigerianAddress("Banana Island, Ikoyi", "Lagos"),
    description: "Ultra-modern penthouse in exclusive estate with panoramic views.",
    price: 12000000,
    status: "Sponsored",
    slug: "ultra-modern-penthouse",
    beds: 5,
    baths: 5,
    sqft: 4200,
    isVerified: true
  },
  {
    id: "spon3",
    imageUrl: "/images/avatars/placeholder.png",
    title: "Luxury duplex with pool",
    address: generateNigerianAddress("GRA", "Port Harcourt"),
    description: "Luxury duplex with private pool and garden in secure environment.",
    price: 4500000,
    status: "Sponsored",
    slug: "luxury-duplex-pool",
    beds: 4,
    baths: 4,
    sqft: 3500,
    daysListed: 2
  },
  {
    id: "spon4",
    imageUrl: "/images/avatars/placeholder.png",
    title: "Exclusive 4-bedroom terrace",
    address: generateNigerianAddress("Lekki Phase 1", "Lagos"),
    description: "Exclusive 4-bedroom terrace house with smart home features.",
    price: 3200000,
    status: "Sponsored",
    slug: "exclusive-4-bedroom-terrace",
    beds: 4,
    baths: 3,
    sqft: 2800,
    isNew: true
  },
  {
    id: "spon5",
    imageUrl: "/images/avatars/placeholder.png",
    title: "Waterfront 3-bedroom apartment",
    address: generateNigerianAddress("Ozumba Mbadiwe", "Lagos"),
    description: "Waterfront 3-bedroom apartment with exceptional views.",
    price: 2800000,
    status: "Sponsored",
    slug: "waterfront-3-bedroom",
    beds: 3,
    baths: 3,
    sqft: 2100,
    isVerified: true
  },
];

// Featured listings
export const featuredListings: PropertyCardProps['property'][] = [
  {
    id: "feat1",
    imageUrl: "/images/avatars/placeholder.png",
    title: "Elegant mansion with smart home",
    address: generateNigerianAddress("Osborne Road, Ikoyi", "Lagos"),
    description: "Elegant mansion with smart home features and 24/7 security.",
    price: 250000000,
    status: "Featured",
    slug: "elegant-mansion-smart-home",
    beds: 6,
    baths: 7,
    sqft: 8000,
    isVerified: true
  },
  {
    id: "feat2",
    imageUrl: "/images/avatars/placeholder.png",
    title: "Contemporary villa",
    address: generateNigerianAddress("Maitama", "Abuja"),
    description: "Contemporary villa in diplomatic zone with luxury finishes.",
    price: 180000000,
    status: "Featured",
    slug: "contemporary-villa-diplomatic",
    beds: 5,
    baths: 6,
    sqft: 6000,
    isNew: true
  },
  {
    id: "feat3",
    imageUrl: "/images/avatars/placeholder.png",
    title: "Spacious family home",
    address: generateNigerianAddress("Old GRA", "Enugu"),
    description: "Spacious family home with lush gardens and serene environment.",
    price: 95000000,
    status: "Featured",
    slug: "spacious-family-home",
    beds: 4,
    baths: 4,
    sqft: 3200,
    daysListed: 5
  },
  {
    id: "feat4",
    imageUrl: "/images/avatars/placeholder.png",
    title: "Luxury 5-bedroom duplex",
    address: generateNigerianAddress("Asokoro", "Abuja"),
    description: "Luxury 5-bedroom duplex with swimming pool and modern amenities.",
    price: 220000000,
    status: "Featured",
    slug: "luxury-5-bedroom-duplex",
    beds: 5,
    baths: 5,
    sqft: 5500,
    isVerified: true
  },
  {
    id: "feat5",
    imageUrl: "/images/avatars/placeholder.png",
    title: "Exquisite waterfront property",
    address: generateNigerianAddress("Banana Island", "Lagos"),
    description: "Exquisite waterfront property with private jetty and panoramic views.",
    price: 850000000,
    status: "Featured",
    slug: "exquisite-waterfront-property",
    beds: 7,
    baths: 8,
    sqft: 10000,
    isNew: true
  },
];

// Export all mock data
export const mockData = {
  rentProperties,
  saleProperties,
  sponsoredListings,
  featuredListings
}; 